export const ERRORS_CODE = {
    VALIDATION_ERROR: "VALIDATION_ERROR",
    UNIQUE: "unique",
    INVALID: "invalid",
    ORGANIZATION_NOT_FOUND: "ORGANIZATION_NOT_FOUND",
    CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION: "CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION",
    PASSWORD_NOT_MATCH: "PASSWORD_NOT_MATCH",
    UNKNOWN_ERROR: "UNKNOWN_ERROR",
    AI_MODEL_NOT_FOUND: "AI_MODEL_NOT_FOUND",
    AI_MODEL_LAYER_NOT_FOUND: "AI_MODEL_LAYER_NOT_FOUND",
    AI_MODEL_TRAIN_NOT_FOUND: "AI_MODEL_TRAIN_NOT_FOUND",
    USER_NOT_FOUND: "USER_NOT_FOUND",
    ACTION_NOT_ALLOW: "ACTION_NOT_ALLOW",
    NO_PLAN_SUBSCRIBE: "NO_PLAN_SUBSCRIBE",
    SUBSCRIPTION_IS_NOT_ACTIVE: "SUBSCRIPTION_IS_NOT_ACTIVE",
    SUBSCRIPTION_NOT_FOUND: "SUBSCRIPTION_NOT_FOUND",
    ORGANIZATION_IS_MAX_AI_MODEL_VOLUME: "ORGANIZATION_IS_MAX_AI_MODEL_VOLUME",
    TOKEN_INVALID: "token_not_valid",
    AI_MODEL_COUNT_GREATER_THAN_PLAN_MAX_VOLUME: "AI_MODEL_COUNT_GREATER_THAN_PLAN_MAX_VOLUME"
};
